import store from '../store'

export default class Newsletter {
  constructor () {
    ({ dom: this.dom } = store)

    // Return if there is no open exampleModal btn
    if (!this.dom.openModal) { return }

    this.addEvents()
  }

  addEvents () {
    // Open newsletter
    this.dom.openModal.addEventListener('click', (event) => { this.openModal() })
    // Close newsletter
    this.dom.closeModal.addEventListener('click', (event) => { this.closeModal() })
  }

  openModal () {
    this.dom.body.classList.add('has-open-modal')
    this.dom.exampleModal.classList.add('is-open')
  }

  closeModal () {
    this.dom.body.classList.remove('has-open-modal')
    this.dom.exampleModal.classList.remove('is-open')
  }
}
